var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.95,
    height: 95.812,
    viewBox: "0 0 270.95 95.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.753,
    y1: -0.256,
    x2: 0.446,
    y2: 0.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dc3c54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#b22c58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f1e5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.481,
    y1: -0.07,
    x2: 0.53,
    y2: 0.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.588,
    y1: -0.113,
    x2: 0.454,
    y2: 0.976,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.452,
    y1: 0.075,
    x2: 0.535,
    y2: 1.053,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.294,
    y1: 0.18,
    x2: 0.692,
    y2: 1.165,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.31,
    y1: 0.328,
    x2: 0.66,
    y2: 1.096,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.262,
    y1: 0.012,
    x2: 0.705,
    y2: 0.917,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592",
    transform: "translate(101.728 38.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M314.48,148.657a39.3,39.3,0,0,1,5.912-.4c3.674,0,6.058.659,7.921,2.067,2.006,1.489,3.271,3.873,3.271,7.287,0,3.7-1.35,6.257-3.207,7.839-2.038,1.693-5.138,2.494-8.908,2.494a37.983,37.983,0,0,1-4.964-.289Zm4.39,15.786a8.116,8.116,0,0,0,1.522.086c3.959.028,6.542-2.138,6.542-6.77.028-4.016-2.323-6.14-6.083-6.14a9.171,9.171,0,0,0-1.981.171Z",
    transform: "translate(-314.48 -148.254)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M373.221,163.034,371.832,168H367.31l5.912-19.342h5.737l6,19.342h-4.7l-1.493-4.967Zm4.907-3.271-1.2-4.1c-.356-1.147-.691-2.583-.976-3.731h-.057c-.289,1.147-.574,2.612-.891,3.731l-1.147,4.1Z",
    transform: "translate(-348.485 -148.513)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M420.5,152.344h-5.2V148.66h14.859v3.684h-5.274v15.679H420.5Z",
    transform: "translate(-379.375 -148.513)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M461.721,163.028l-1.375,4.964H455.81l5.911-19.342h5.741l6,19.342h-4.7l-1.475-4.964Zm4.91-3.271-1.208-4.1c-.356-1.147-.688-2.583-.976-3.731h-.057c-.285,1.147-.574,2.612-.887,3.731l-1.151,4.1Z",
    transform: "translate(-405.45 -148.507)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M514.6,148.652a36.053,36.053,0,0,1,5.911-.4c2.7,0,4.632.517,5.911,1.55a5.637,5.637,0,0,1,2.067,4.476,6.172,6.172,0,0,1-1.782,4.593,8.98,8.98,0,0,1-6.286,2.035,11.113,11.113,0,0,1-1.493-.086v6.916H514.6Zm4.333,8.773a6.749,6.749,0,0,0,1.464.114c2.323,0,3.759-1.176,3.759-3.157,0-1.782-1.233-2.851-3.414-2.851a7.523,7.523,0,0,0-1.81.171Z",
    transform: "translate(-443.291 -148.249)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M563.4,148.66h4.394v15.679h7.69v3.674H563.4Z",
    transform: "translate(-474.702 -148.513)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M609.011,163.028l-1.375,4.964H603.1l5.911-19.342h5.741l6,19.342h-4.7l-1.493-4.964Zm4.91-3.271-1.208-4.1c-.356-1.147-.688-2.583-.973-3.731h-.06c-.285,1.147-.574,2.612-.887,3.731l-1.147,4.1Z",
    transform: "translate(-500.256 -148.507)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M655.765,168V160.08l-6.115-11.42h4.989l1.977,4.65c.6,1.4,1,2.437,1.493,3.7h.057c.431-1.208.891-2.327,1.464-3.7l1.953-4.65h4.907l-6.371,11.278V168Z",
    transform: "translate(-530.218 -148.513)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M714.876,159.827h-7.127v4.593h7.961v3.585H703.37V148.66h11.937v3.588H707.76v4.016h7.127Z",
    transform: "translate(-564.796 -148.513)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M748.39,148.657a38.647,38.647,0,0,1,5.826-.4c2.851,0,4.878.428,6.254,1.518a4.92,4.92,0,0,1,1.782,4.048,5.135,5.135,0,0,1-3.417,4.764v.086c1.35.545,2.1,1.839,2.583,3.617.6,2.181,1.2,4.707,1.579,5.452h-4.476a24.413,24.413,0,0,1-1.351-4.5c-.516-2.412-1.347-3.072-3.129-3.1h-1.318v7.6H748.39Zm4.333,8.324h1.721c2.181,0,3.474-1.09,3.474-2.783,0-1.782-1.208-2.669-3.207-2.7a10.936,10.936,0,0,0-1.978.143Z",
    transform: "translate(-593.774 -148.254)",
    fill: "#901f5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M220.373,80.45l.057-.05c-.356.021-.713.061-1.044.11-.264.036-.527.082-.787.135a14.531,14.531,0,0,0-2.352.673,14.685,14.685,0,0,0-5.345,3.5c-.039.3-.071.609-.1.916a29.111,29.111,0,0,0,.413,8.288c.991,5.1,3.121,10.223,10.109,14.674h.057l.356-.11a20.6,20.6,0,0,1-1.39-28.068A.137.137,0,0,1,220.373,80.45Z",
    transform: "translate(-135.603 -51.751)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M186.79,46.351c-.061.46-.114.923-.157,1.386A37.942,37.942,0,0,0,190.71,68.76c.1.2.214.4.321.6q.42.784.873,1.543a37.853,37.853,0,0,0,11.4,12.023c.1.071.2.143.3.21l.118.071.039-.039.125-.121c.071-.061.143-.114.217-.167a4.415,4.415,0,0,1,1.048-.449c-7.283-4.5-9.478-9.717-10.487-14.905a29.449,29.449,0,0,1-.513-6.77c0-.378.036-.755.068-1.13a29.219,29.219,0,0,1,10.622-20.243c-.167-.018-.356-.028-.506-.039-.339-.025-.673-.046-1.012-.053a21.69,21.69,0,0,0-4.668.392A21.458,21.458,0,0,0,186.79,46.351Z",
    transform: "translate(-120.019 -25.284)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M160.808,50.819q.959,1.425,2.035,2.769l.42.524A44.744,44.744,0,0,0,177.4,65.6l.453.232q1.821.912,3.706,1.657a4.307,4.307,0,0,1,.2-.406l-.068-.043c-.182-.114-.356-.228-.545-.356-.306-.2-.609-.41-.909-.616h-.021a37.9,37.9,0,0,1-9.111-9c-.438-.613-.859-1.247-1.269-1.892-.584-.934-1.14-1.9-1.657-2.893a37.943,37.943,0,0,1-4.162-19.694c.036-.538.075-1.069.128-1.611a38.305,38.305,0,0,1,6.51-17.738q-.973.185-1.938.442A28.278,28.278,0,0,0,153.1,24.372a44.684,44.684,0,0,0,7.7,26.447Z",
    transform: "translate(-98.533 -8.522)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M129.784,50.753a51.3,51.3,0,0,0,23.044,10.369l.6.1.043-.214c.018-.068.032-.135.05-.2a44.638,44.638,0,0,1-17.984-12.354q-.581-.652-1.137-1.336A45.012,45.012,0,0,1,127.678,1.44q-1.069.449-2.138.98A33.367,33.367,0,0,0,110,18.932a53.094,53.094,0,0,0,11.777,24.231,53.618,53.618,0,0,0,8.007,7.59Z",
    transform: "translate(-70.801 -0.927)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M84.823,53.314a59.474,59.474,0,0,0,6.952,3.848A57.929,57.929,0,0,0,120.8,62.508c.556-.043,1.112-.1,1.668-.153,0-.16-.018-.321-.029-.481v-.6q-1.953-.289-3.891-.713a52.969,52.969,0,0,1-20.778-9.735,53.648,53.648,0,0,1-4.739-4.1A53.026,53.026,0,0,1,78.245,20.257,53.535,53.535,0,0,1,77.625,0c-.745.542-1.475,1.112-2.184,1.71A39.45,39.45,0,0,0,62,24.961,57.836,57.836,0,0,0,84.823,53.314Z",
    transform: "translate(-39.905 0)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M55.385,83.395a61.8,61.8,0,0,0,12.906,1.354,60.933,60.933,0,0,0,23.482-4.675q-2.327.171-4.668.153a57.932,57.932,0,0,1-24.231-5.505l-.456-.221A57.968,57.968,0,0,1,33.677,43.956a58.556,58.556,0,0,1-4.2-18.661V25.22c-.67.755-1.315,1.532-1.931,2.338a43.116,43.116,0,0,0-8.491,32.334,60.851,60.851,0,0,0,36.332,23.5Z",
    transform: "translate(-11.985 -16.233)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M85.206,138.845c-.909,0-1.5-.6-1.782-1.764-.282-1.24-.463-2.523-.6-3.613a2.627,2.627,0,0,0-.039-.331l-.043-.381-.053-.506-.032-.321a60.893,60.893,0,0,1-26.924,6.236q-2.9,0-5.723-.264a61.115,61.115,0,0,1-39.916-20.193q-1.315-1.486-2.53-3.057a.246.246,0,0,1,0,.046,61.022,61.022,0,0,1-5.74-8.776c-.3,1.016-.535,2.081-.763,3.121a45.218,45.218,0,0,0,84.732,29.69,1.75,1.75,0,0,1-.577.1Z",
    transform: "translate(0.006 -68.177)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M179.153,167.1a14.859,14.859,0,1,1,14.855-14.858A14.86,14.86,0,0,1,179.153,167.1Z",
    transform: "translate(-105.746 -88.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 13.598,
    cy: 13.598,
    r: 13.598,
    transform: "translate(59.816 50.214)",
    fill: "#901f5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M205.9,162.637l-9.667-7.372a1.2,1.2,0,0,0-1.935.955v14.749a1.2,1.2,0,0,0,1.935.955l9.667-7.372a1.2,1.2,0,0,0,0-1.913Z",
    transform: "translate(-125.063 -99.78)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGradient);
export default __webpack_public_path__ + "static/media/logoGradient.a9d1eb27.svg";
export { ForwardRef as ReactComponent };